let BASE_URL = "";
const host = `be.${window.location.hostname}`;
const prodHost = `be.app.novustrac.com`;
const protocol = window.location.protocol;
const port = "443";
//========================================//
const localHost = "be.app.novustrac.com";
//  const localHost = "fbe56f874679.ngrok.io";
const localProtocol = "https:";

if (
  window.location.hostname === "localhost" ||
  window.location.hostname.includes("devapp")
) {
  // BASE_URL = `${localProtocol}//${localHost}:${port}`;
  BASE_URL = "https://be.devapp.novustrac.com"
} else if(window.location.hostname.includes("qaapp")){
  BASE_URL = "https://be.qaapp.novustrac.com"
}
 else {
  BASE_URL = `${protocol}//${prodHost}:${port}`;
}

console.log(BASE_URL);

export const config = {
  paymentkey:"pk_live_XcXnuMNeoD7xZZv8F4gctJ3C00ebI6kmCa",
  // paymentkey:"pk_test_kNsFIIFXnhck7ojUVYPZc7Nf00vafeMzh8",
  BASE_URL: BASE_URL,
  GRANT_TYPE: "password",
  Content_Type: "multipart/form-data",
  Authorization_Token:
    "c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA=="
};



// WEBPACK FOOTER //
// ./src/config/appConfig.js